class LoginPage {
  // Constructor
  constructor() {
    this.checkLoginPage();
  }

  // Check if the URL is /login
  checkLoginPage() {
    const urlParams = new URLSearchParams(window.location.search);
    const action = urlParams.get('action');
    const errors = urlParams.get('errors');

    if (
      window.location.pathname === '/login' ||
      window.location.pathname === '/login/'
    ) {
      if (action === 'reset_pass' && errors === 'empty_username') {
        this.changeLinkText('Return to Login');
        this.changeLabelText('Email Address');
      } else if (action === 'reset_pass') {
        this.changeLinkText('Return to Login');
        this.changeLabelText('Email Address');
      } else {
        this.changeLinkText('Reset Password');
      }
    }
  }

  // Change the inner text of the anchor tag in the div pmpro_actions_nav
  changeLinkText(text) {
    document.addEventListener('DOMContentLoaded', () => {
      const actionsNav = document.querySelector('.pmpro_actions_nav a');
      if (actionsNav) {
        actionsNav.innerText = text;
      }
    });
  }

  // Change the inner text of the label for user_login
  changeLabelText(text) {
    document.addEventListener('DOMContentLoaded', () => {
      const label = document.querySelector('label[for="user_login"]');
      if (label) {
        label.childNodes[0].nodeValue = text;
      }
    });
  }
}

export default LoginPage;
